export default __webpack_public_path__ + "images/ftm_ae0f64.svg";